import SchoolIcon from "@mui/icons-material/School";
import { tenants } from "utils/tenants";
import permissions from "app/permissions";
import EnrollDoctorant from "./ApprovedCandidacies/Enroll/EnrollDoctorant";
import ExternalDoctoralSchoolCandidate from "./DoctoralSchoolCampaigns/ExternalCandidate/ExternalDoctoralSchoolCandidate";
import { resources as DoctoralDisciplines } from "./Disciplines";
import { resources as HigherEducationFields } from "./HigherEducationFields";
import { resources as DoctoralPrograms } from "./DoctoralPrograms";
import { resources as DoctoralSeats } from "./DoctoralSeats";
import { resources as DoctoralCampaigns } from "./DoctoralCampaigns";
import { resources as DoctoralSchoolCampaigns } from "./DoctoralSchoolCampaigns";
import { resources as DoctoralSchoolFees } from "./DoctoralSchoolFees";
import { resources as DoctorantCandidacies } from "./DoctorantCandidacies";
import { resources as DoctoralSeatApprovals } from "./DoctoralSeatApprovals";

export const resources = {
  isMenu: true,
  tenancies: [tenants.MU],
  icon: <SchoolIcon />,
  name: "Докторанти",
  title: "Докторанти",
  subMenu: [
    HigherEducationFields,
    DoctoralDisciplines,
    DoctoralPrograms,
    DoctoralSeats,
    DoctoralSeatApprovals,
    DoctoralCampaigns,
    DoctorantCandidacies,
    {
      isMenu: false,
      custom: <EnrollDoctorant />,
      name: "doctoral/enroll-doctorant",
      permission: permissions.canEnrollDoctorants,
    },
    {
      isMenu: false,
      custom: <ExternalDoctoralSchoolCandidate />,
      name: "doctoral/doctoral-school-external-candidate",
      permission: permissions.canManageDoctoralSchoolDoctorants,
    },
    DoctoralSchoolCampaigns,
    DoctoralSchoolFees,
  ],
};
